module.exports = __webpack_public_path__ + "img/MIGRATION.a96fd3d0.svg";